<script setup lang="ts">
import { computed, inject, onMounted, ref, watch } from "vue";
import type { Ref } from "vue";

interface TabSetContext {
    tabs: Ref<{ disabled?: boolean }[]>;
    activeTabIndex: { value: number };
    registerTab: (tab: any) => void;
    selectTab: (index: number) => void;
}

const props = defineProps({
    heading: {
        type: String,
        required: true,
    },
    number: {
        type: Number,
        default: undefined,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const tabset = inject<TabSetContext>("tabset");
const tabIndex = ref(0);

onMounted(() => {
    if (tabset) {
        const newTab = {
            heading: props.heading,
            number: props.number,
            disabled: props.disabled,
            index: 0,
        };
        tabset.registerTab(newTab);
        tabIndex.value = newTab.index;
    }
});

watch(
    () => props.disabled,
    (newDisabled) => {
        if (tabset?.tabs.value[tabIndex.value] != null) {
            tabset.tabs.value[tabIndex.value].disabled = newDisabled;
        }
    },
);

const isActive = computed(() => {
    return tabset?.activeTabIndex.value === tabIndex.value;
});
</script>

<template>
    <div v-show="isActive" class="tab-pane" :class="{ active: isActive }">
        <slot></slot>
    </div>
</template>
